<template>
    <div class="mb-3">
        <div class="section-header" :class="{ open: !collapsed }" @click="collapsed = !collapsed" role="button"
            tabindex="0" @keydown.enter.space.prevent="collapsed = !collapsed" :aria-expanded="!collapsed">
            <div class="section-header-left">
                <span class="section-title">
                    Groupes affichés
                    <span v-if="groups && groups.length" class="section-title-count">
                        {{ selectedCount }}/{{ groups.length }}
                    </span>
                </span>
            </div>
            <span class="section-chevron" :class="{ open: !collapsed }" aria-hidden="true">▾</span>
        </div>

        <!-- Ligne actions uniquement quand c’est ouvert -->
        <div v-if="!collapsed" class="d-flex align-items-center justify-content-end text-muted small mb-2">
            <button v-if="groups && groups.length" type="button"
                class="btn btn-link btn-sm p-0 lh-1 text-decoration-none mini-link" @click="toggleAll"
                :aria-label="allSelected ? 'Décocher tous les groupes' : 'Cocher tous les groupes'">
                {{ allSelected ? 'Décocher tout' : 'Cocher tout' }}
            </button>
        </div>

        <div v-if="!collapsed" class="groups-scroll">
            <label v-for="g in groups" :key="g.id" class="group-row d-flex align-items-center mb-1" :title="g.name">
                <span class="form-check-label text-truncate">{{ g.name }}</span>
                <input class="form-check-input" type="checkbox" :checked="!!g.selected"
                    @change="$emit('toggle-group', { id: g.id, selected: $event.target.checked })" />
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PanelGroupsSection',
    props: {
        groups: { type: Array, default: () => [] }, // [{id, name, selected}]
    },
    emits: ['toggle-group', 'hide-all'],
    data() {
        return {
            collapsed: true, // replié par défaut
        };
    },
    computed: {
        allSelected() {
            return Array.isArray(this.groups) && this.groups.length > 0 && this.groups.every(g => !!g.selected);
        },
        selectedCount() {
            return Array.isArray(this.groups) ? this.groups.filter(g => !!g.selected).length : 0;
        },
    },
    methods: {
        toggleAll() {
            if (!Array.isArray(this.groups) || !this.groups.length) return;

            if (this.allSelected) {
                this.$emit('hide-all');
                return;
            }

            this.groups
                .filter(g => !g.selected)
                .forEach(g => {
                    this.$emit('toggle-group', { id: g.id, selected: true });
                });
        },
    },
}
</script>

<style scoped>
.mini-link {
    font-size: .8rem;
    line-height: 1;
    padding: 0;
}

.groups-scroll {
    overflow: visible;
    padding-right: .25rem;
}

.groups-scroll .form-check-label {
    inline-size: 100%;
}

/* Aligne le texte à gauche et toutes les checkboxes sur une même colonne à droite */
.group-row {
    width: 100%;
    justify-content: space-between;
    /* pousse la checkbox complètement à droite */
    gap: .5rem;
}

.group-row .form-check-label {
    flex: 1 1 auto;
    /* le libellé prend tout l’espace restant */
}

.group-row .form-check-input {
    flex: 0 0 auto;
    /* taille fixe à droite */
    margin: 0 0 0 .5rem;
    /* petit espacement avec le texte */
}

.section-header {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .75rem;
    min-height: 42px;
    padding: .65rem .8rem;
    margin-bottom: .75rem;
    border: 1px solid rgba(0, 0, 0, .08);
    border-radius: .75rem;
    background: #f8f9fa;
    color: #495057;
    transition: background-color .15s ease, border-color .15s ease, box-shadow .15s ease;
    user-select: none;
}

.section-header:hover,
.section-header:focus {
    background: #eef3f8;
    border-color: rgba(13, 110, 253, .25);
    box-shadow: 0 0 0 3px rgba(13, 110, 253, .08);
    outline: none;
}

.section-header.open {
    background: #eef4ff;
    border-color: rgba(13, 110, 253, .28);
}

.section-header-left {
    display: flex;
    align-items: center;
    min-width: 0;
}

.section-title {
    font-size: .9rem;
    font-weight: 600;
    color: #212529;
    display: inline-flex;
    align-items: center;
    gap: .4rem;
}

.section-title-count {
    font-size: .82rem;
    font-weight: 700;
    color: #0d6efd;
}

.section-chevron {
    flex: 0 0 auto;
    width: 2rem;
    height: 2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: rgba(0, 0, 0, .05);
    color: #495057;
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1;
    transform: rotate(-90deg);
    transition: transform .18s ease, background-color .18s ease, color .18s ease;
}

.section-chevron.open {
    transform: rotate(0deg);
    background: rgba(13, 110, 253, .12);
    color: #0d6efd;
}
</style>
